import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog";
import { MONITORING_COPY } from "./monitoring-constants";

type Props = {
  /** Closes the confirmation and keeps the form open. */
  onKeepEditing: () => void;
  /** Closes the confirmation and the form, dropping the draft. */
  onDiscard: () => void;
};

/** Confirms closing a dirty monitoring form. Mount it only while asking. */
export function DiscardChangesDialog({ onKeepEditing, onDiscard }: Props) {
  return (
    <AlertDialog open onOpenChange={(open) => !open && onKeepEditing()}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>{MONITORING_COPY.discardTitle}</AlertDialogTitle>
          <AlertDialogDescription>
            {MONITORING_COPY.discardDescription}
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel>
            {MONITORING_COPY.discardKeepEditing}
          </AlertDialogCancel>
          <AlertDialogAction onClick={onDiscard}>
            {MONITORING_COPY.discardConfirm}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
